import { useQuery } from "@tanstack/react-query";
import { fetchUsers } from "../services/users";
import { UserOrderingField } from "../types/api/users";

export const useUsersQuery = (
  search: string = "",
  page: number,
  limit: number,
  isBlocked?: boolean,
  ordering?: UserOrderingField
) => {
  return useQuery({
    refetchOnWindowFocus: false,
    queryKey: ["users", search, page, limit, isBlocked, ordering],
    queryFn: () =>
      fetchUsers({
        search: search || undefined,
        limit,
        offset: (page - 1) * limit,
        is_blocked: isBlocked,
        ordering,
      }),
    retry: 0,
  });
};
